import { ref, get, set, remove } from 'firebase/database';
import { getAuth, deleteUser } from 'firebase/auth';
import { db } from '../lib/firebase';
import { UserProfile, Purchase } from '../types/profile';

export const getUserProfile = async (userId: string): Promise<UserProfile | null> => {
  const profileRef = ref(db, `profiles/${userId}`);
  const snapshot = await get(profileRef);
  return snapshot.exists() ? snapshot.val() : null;
};

export const updateUserProfile = async (userId: string, data: Partial<UserProfile>): Promise<void> => {
  const profileRef = ref(db, `profiles/${userId}`);
  const currentProfile = await getUserProfile(userId);
  
  await set(profileRef, {
    ...currentProfile,
    ...data,
    updatedAt: new Date().toISOString()
  });
};

export const getPurchaseHistory = async (userId: string): Promise<Purchase[]> => {
  const purchasesRef = ref(db, `purchases/${userId}`);
  const snapshot = await get(purchasesRef);
  
  if (!snapshot.exists()) {
    return [];
  }
  
  return Object.entries(snapshot.val()).map(([id, data]) => ({
    id,
    ...(data as Omit<Purchase, 'id'>)
  }));
};

export const deleteUserAccount = async (userId: string): Promise<void> => {
  const auth = getAuth();
  const user = auth.currentUser;

  if (!user) {
    throw new Error('Utilisateur non connecté');
  }

  // Supprime toutes les données de l'utilisateur
  await Promise.all([
    remove(ref(db, `profiles/${userId}`)),
    remove(ref(db, `purchases/${userId}`)),
    remove(ref(db, `estimates/${userId}`)),
    remove(ref(db, `user_data/${userId}`))
  ]);

  // Supprime le compte Firebase
  await deleteUser(user);
};